import { getCurrentVersion } from 'utils/CacheControl/VedaClientCacheControl';
import { pageApis } from '../apis';

export const getPageCounterService = async () => {
  return pageApis.vedaApplication.userApi.page.getCoutner({
    cacheVersion: getCurrentVersion().getTime(),
  });
};
